<template lang="pug">
.container.col-centered
  .row
    h2.main_title
      | MT Firmware
      .pull-right
        button.btn.btn-primary(v-on:click="handleShowModal('upload')" v-if="user.role === 'admin'")
          span.glyphicon.glyphicon-plus
          span  New
    .col-md-12.function_bar(style="display:flex; justify-content: space-between; align-items: center;")
      .form-group
        label.control_label
          | Search:
        tooltip(effect="scale" placement="bottom" content="Search by version or release notes")
          input.form-control(v-model="temporarySearchQuery" @keydown.enter="applySearchQuery" placeholder="Search..." style="display: inline-block; width: auto; vertical-align: middle;")
      .form-group
        label.control_label
          | Category:
        v-select(v-bind:value.sync='logFilter.category.value' v-bind:options='logFilter.category.opts')
      //- .form-group.col-md-3
      //-   label.control_label
      //-     | Custom:
      //-   v-select(v-bind:value.sync='logFilter.custom.value' v-bind:options='logFilter.custom.opts')
      .form-group
        label.control_label
          | Status:
        v-select(v-bind:value.sync='logFilter.status.value' v-bind:options='logFilter.status.opts')
    spinner(v-ref:spinner size="md" show="true" text="Loading...")
    div
      pagination(
        v-bind:sort-method.sync="sortMethod"
        v-bind:sort-method-opts="sortMethodOpts"
        v-bind:count-of-page.sync="countOfPage"
        v-bind:curr-page.sync="currPage"
        v-bind:count-of-pagination="countOfPagination"
        v-bind:curr-pagination-sec.sync='currPaginationSec'
        v-bind:target-ary.sync='searchFilteredList'
        v-bind:expand-all.sync='expandAll'
        v-bind:show-toggle-expansion-btn='true'
      )
      .col-md-12
        table.table.table-bordered.table-hover.log_table
          tr(v-for="($index, p) in searchFilteredList | limitBy countOfPage pageStart")
            td {{$index + 1 + pageStart}}
            td.single_log
              .media(style="overflow: visible;")
                .media-left
                  .media-object.device_icon(v-bind:class="p.category")
                    img(v-bind:src="getIconSrc(p.category)")
                .media-body(style="overflow: visible;")
                  .media-top
                    span.media-top__info
                      .version-row
                        span.version
                          span(style="margin-right: 4px" v-html='highlightMatches(p.version, searchQuery)')
                          span.glyphicon.glyphicon-link(class="copy-icon" @click="copyToClipboard(p.version)" style="font-size: medium;")
                        span.model.type_tag.base_black.base_grey_bg {{getCustomForUI(p.custom)}}
                        span.model.type_tag.base_black.base_white_bg(v-if="p.isReadOnly && user.role === 'admin'") ReadOnly
                      span.time
                        span.glyphicon.glyphicon-time
                        span(v-if="sortMethod.name !== 'updatedAt'") Released at {{ p.createdAt | fromNow }}
                        span(v-if="sortMethod.name === 'updatedAt'") Updated at {{ p.updatedAt | fromNow }}
                    .action_buttons
                      .btn-group
                        button.btn.btn-sm.btn-default(@click="handleShowModal('update', p['.key'], $index)" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-pencil
                        button.btn.btn-sm.btn-default(@click="handleShowDeleteConfirm(p['.key'])" v-if="user.role === 'admin'")
                          span.glyphicon.glyphicon-trash
                        button.btn.btn-sm.btn-default(@click="markAsProduction(p['.key'])" v-if="isLantechQA && p.status === 'release'")
                          span.glyphicon.glyphicon-ok
                          span  Mark as Production
                        a.btn.btn-sm.btn-default(v-on:click='handleDownload(p.url, $event)' v-bind:disabled="!p.url")
                          span.glyphicon.glyphicon-cloud-download
                          span  MT Firmware
                        a.btn.btn-sm.btn-default(v-on:click='handleDownload(p.programmingFileUrl, $event)' v-bind:disabled="!p.programmingFileUrl")
                          span.glyphicon.glyphicon-cloud-download
                          span  Programming File
                        a.btn.btn-sm.btn-default(v-on:click='handleDownload(p.testReportUrl, $event)' v-bind:disabled="!p.testReportUrl")
                          span.glyphicon.glyphicon-list-alt
                          span  Test Report
                  .media-middle
                    line-table(title='Firmware MD5' v-bind:content='p.md5' v-if='p.md5 != null && p.md5.length !== 0')
                    line-table(title='Programming File MD5' v-bind:content='p.programmingFileMd5' v-if='p.programmingFileMd5 != null && p.programmingFileMd5.length !== 0')
                    line-table(
                      title='Release Notes'
                      v-bind:is-md="true"
                      v-bind:default-collapse="!(searchQuery.trim() !== '' && p.releaseNote && p.releaseNote.toLowerCase().includes(searchQuery.toLowerCase()))"
                      v-bind:content='highlightMatches(p.releaseNote, searchQuery, false)'
                      v-if='p.releaseNote && p.releaseNote.length !== 0'
                      v-bind:expand-all='expandAll'
                    )
                    div(v-if='(user.role === "admin" || isIntrising) && p.hasInternalLog' @click="fetchInternalLog(p['.key'])")
                      line-table(
                        title='Internal Logs'
                        v-bind:is-md="true"
                        v-bind:default-collapse="true"
                        v-bind:content='internalLogs[p[".key"]] || ""'
                        v-bind:expand-all='expandAll'
                      )
            td.badge_group
              .customized__badge(v-bind:class="p.status")
                span {{p.status}}
      .col-md-12(v-if="searchFilteredList.length <= 0")
        h3.text-center.text-muted No Data
  modal(
    v-bind:title.sync='modalTitle'
    v-bind:ok-text.sync='okText'
    backdrop='false'
    large='true'
    v-bind:callback='modalCb'
    v-bind:show.sync='showModal')
    .modal-body.upload_modal(slot='modal-body')
      .col-md-12.clearfix.col-centered
        .form-group.col-md-12.clearfix(v-if='form.isUpdate')
          .col-md-3.form_label.clearfix
            label.control_label
              | Last update:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='form.isUpdatedAt' readonly)
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Date:
          .col-md-9.no_pad.clearfix
            datepicker(v-bind:value.sync="form.isReleasedAt" v-bind:format="'yyyy/M/dd'" placeholder="Default is current time.")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Category:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='mtCategory' v-bind:value.sync='form.selectedCategory')
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Custom:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='customOpts' v-bind:value.sync='form.selectedCustom' v-bind:disabled="true")
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Version:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='form.version' placeholder='V1.00.01')
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | MT Firmware
              |
              span.glyphicon.glyphicon-cloud-download
              | :
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='form.url' placeholder='https://...')
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Firmware MD5:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='form.md5' placeholder='')
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Programming File
              |
              span.glyphicon.glyphicon-cloud-download
              | :
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='form.programmingFileUrl' placeholder='https://...')
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Programming File MD5:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='form.programmingFileMd5' placeholder='')
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Test Report:
          .col-md-9.no_pad.clearfix
            input.form-control.input-sm(v-model='form.testReportUrl' placeholder='https://...')
        .form-group.col-md-12.clearfix
          .col-md-3.form_label.clearfix
            label.control_label
              | Status:
          .col-md-9.no_pad.clearfix
            v-select(v-bind:options='statusOpts' v-bind:value.sync='form.selectedStatus')
        .form-group.col-md-12.clearfix.larger_form_group
          .col-md-3.form_label.clearfix
            label.control_label
              | Release Notes:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='form.releaseNote' placeholder='')
        .form-group.col-md-12.clearfix.larger_form_group(v-if="user.role === 'admin' || isIntrising")
          .col-md-3.form_label.clearfix
            label.control_label
              | Internal Logs:
          .col-md-9.no_pad.clearfix
            textarea.form-control(v-model='form.internalLog' placeholder='' v-bind:disabled="user.role !== 'admin'")
        .form-group.col-md-12.clearfix(v-if="user.role === 'admin'")
          .col-md-3.form_label.clearfix
            label.control_label(style="padding-top:4px;") Is Read Only:
          .col-md-9.no_pad.clearfix
            checkbox(:checked.sync="form.isReadOnlyStr" value="true")
  modal(
    title='Confirm'
    v-bind:show.sync='showDeleteConfirm')
    .modal-body(slot='modal-body')
      h4.text-center Are you sure to delete?
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click='showDeleteConfirm = false')
        | No
      button.btn.btn-danger(@click='applyDelete')
        | Yes
  modal(
    title='Confirm'
    v-bind:show.sync='showMarkAsProductionConfirm')
    .modal-body(slot='modal-body')
      h4.text-center Mark this as Production?
    .modal-footer(slot='modal-footer')
      button.btn.btn-default(@click='showMarkAsProductionConfirm = false')
        | No
      button.btn.btn-primary(@click='applyMarkAsProduction')
        | Yes
  alert(v-bind:show.sync="showAlert" placement="top" duration="5000" type="danger" width="400px" dismissable)
    span(class="icon-info-circled alert-icon-float-left")
    h4 The following fields are required:
      ul
        li(v-if="!form.selectedCategory") Category
        li(v-if="!form.selectedCustom") Custom
        li(v-if="!form.url") MT Firmware
        li(v-if="!form.version") Version
        li(v-if="!form.selectedStatus") Status
        li(v-if="!form.isReleasedAt") Release Date
        li(v-if="!form.md5") Firmware MD5
        li(v-if="form.md5 && form.md5.length !== 32") Firmware MD5 must be 32 characters
        li(v-if="!form.programmingFileUrl") Programming File
        li(v-if="!form.programmingFileMd5") Programming File MD5
        li(v-if="form.programmingFileMd5 && form.programmingFileMd5.length !== 32") Programming File MD5 must be 32 characters
</template>

<script>
import moment from 'moment'
import { alert, datepicker, modal, select, spinner, checkbox, tooltip } from 'vue-strap'
import pagination from '../common/Pagination.vue'
import lineTable from '../common/LinedTable.vue'
import { getDb, getFireBase, getCustomForUI, getIconSrc, filterOptions, naturalSorting, resolveDownloadUrl } from '../../index.js'
import searchMixin from '../../mixins/searchMixin.js'
import clipboardMixin from '../../mixins/clipboardMixin.js'
import permissionsMixin from '../../mixins/permissionsMixin.js'
import _ from 'lodash'

const fb = getFireBase()
const MT_CATEGORY = [
  { label: 'OS2 Pro', value: 'os2_plus' },
  { label: 'OS5', value: 'os5' }
]
const SWITCH_CUSTOM = filterOptions.custom
const DEFAULT_FORM = {
  isUpdate: false,
  isUpdatedAt: '',
  isReleasedAt: '',
  selectedCategory: 'os2_plus',
  selectedCustom: 'lantech_lantech',
  selectedStatus: 'develop',
  version: '',
  url: '',
  md5: '',
  programmingFileUrl: '',
  programmingFileMd5: '',
  testReportUrl: '',
  releaseNote: '',
  internalLog: '',
  isReadOnlyStr: ''
}

export default {
  mixins: [searchMixin, clipboardMixin, permissionsMixin],
  components: {
    alert,
    datepicker,
    modal,
    pagination,
    'v-select': select,
    'line-table': lineTable,
    spinner,
    checkbox,
    tooltip
  },
  vuex: {
    getters: {
      user: state => state.user
    }
  },
  data () {
    return {
      firmwareList: [],
      countOfPage: 50,
      currPage: 1,
      countOfPagination: 5,
      currPaginationSec: 1,
      sortMethod: { name: 'createdAt', asc: false },
      sortMethodOpts: [
        { label: 'Sort by Release Date', value: 'createdAt' },
        { label: 'Sort by Update Time', value: 'updatedAt' },
        { label: 'Sort by Version', value: 'version' }
      ],
      logFilter: {
        category: { opts: [], value: 'any' },
        custom: { opts: [], value: 'any' },
        status: { opts: [], value: 'any' }
      },
      mtCategory: MT_CATEGORY,
      customOpts: SWITCH_CUSTOM,
      statusOpts: filterOptions.status.mtFirmware,
      form: { ...DEFAULT_FORM },
      showModal: false,
      modalTitle: '',
      okText: '',
      modalCb: function () {},
      editingKey: '',
      showDeleteConfirm: false,
      showMarkAsProductionConfirm: false,
      showAlert: false,
      markAsProductionKey: '',
      temporarySearchQuery: '',
      searchQuery: '',
      expandAll: false,
      internalLogs: {}
    }
  },
  ready () {
    this.$refs.spinner.show()
    const optAny = { label: 'Any', value: 'any' }
    this.logFilter.category.opts = [optAny, ...MT_CATEGORY]
    this.logFilter.custom.opts = [optAny, ..._.cloneDeep(SWITCH_CUSTOM)]
    this.logFilter.status.opts = [optAny, ..._.cloneDeep(filterOptions.status.mtFirmware)]
    this.loadData()
  },
  computed: {
    totalList () {
      const { name, asc: isAsc } = this.sortMethod
      if (name === 'version') {
        return naturalSorting(_.filter(this.firmwareList, x => x.version), 'version', isAsc ? 'asc' : 'desc')
      }
      return _.orderBy(this.firmwareList, [name], [isAsc ? 'asc' : 'desc'])
    },
    categoryFilteredList () {
      return this.totalList.filter(p => {
        return this.logFilter.category.value !== 'any' ? p.category === this.logFilter.category.value : true
      })
    },
    customFilteredList () {
      return this.categoryFilteredList.filter(p => {
        return this.logFilter.custom.value !== 'any' ? p.custom === this.logFilter.custom.value : true
      })
    },
    statusFilteredList () {
      if (this.user.role === 'admin' || this.isIntrising) {
        return this.customFilteredList.filter(p => {
          return this.logFilter.status.value !== 'any' ? p.status === this.logFilter.status.value : true
        })
      } else if (this.isLantechQA) {
        return this.customFilteredList.filter(p => {
          if (this.logFilter.status.value !== 'any') return p.status === this.logFilter.status.value
          return ['release', 'production'].includes(p.status)
        })
      } else {
        return this.customFilteredList.filter(p => p.status === 'production')
      }
    },
    searchFilteredList () {
      if (this.searchQuery.trim() === '') return this.statusFilteredList
      const q = this.searchQuery.toLowerCase()
      return this.statusFilteredList.filter(p => {
        return (p.version && p.version.toLowerCase().includes(q)) ||
               (p.releaseNote && p.releaseNote.toLowerCase().includes(q))
      })
    },
    pageStart () {
      return (this.currPage - 1) * this.countOfPage
    }
  },
  methods: {
    getCustomForUI,
    getIconSrc,
    markAsProduction (key) {
      this.markAsProductionKey = key
      this.showMarkAsProductionConfirm = true
    },
    applyMarkAsProduction () {
      getDb().ref('mt-firmware').child(this.markAsProductionKey).update({ status: 'production' })
      this.showMarkAsProductionConfirm = false
    },
    handleDownload (url, e) {
      if (!url) return
      window.open(resolveDownloadUrl(url))
    },
    loadData () {
      getDb().ref('mt-firmware').on('value', sn => {
        this.$refs.spinner.hide()
        this.firmwareList = _.transform(sn.val() || {}, (result, value, key) => {
          result.push({ '.key': key, ...value })
        }, [])
      })
    },
    handleShowModal (which, key, index) {
      this.editingKey = key
      if (which === 'upload') {
        this.modalTitle = 'Add MT Firmware'
        this.okText = 'Add'
        this.form = { ...DEFAULT_FORM, isReleasedAt: moment(new Date()).format('YYYY-MM-DD HH:mm:ss') }
        this.modalCb = this.applyUpload
      } else if (which === 'update') {
        this.modalTitle = 'Edit MT Firmware'
        this.okText = 'Update'
        const item = this.searchFilteredList[index + this.pageStart]
        this.form = {
          isUpdate: true,
          isUpdatedAt: moment(item.updatedAt).format('YYYY-MM-DD HH:mm:ss'),
          isReleasedAt: moment(item.createdAt).format('YYYY-MM-DD HH:mm:ss'),
          selectedCategory: item.category,
          selectedCustom: item.custom,
          selectedStatus: item.status,
          version: item.version,
          url: item.url || '',
          md5: item.md5 || '',
          programmingFileUrl: item.programmingFileUrl || '',
          programmingFileMd5: item.programmingFileMd5 || '',
          testReportUrl: item.testReportUrl || '',
          releaseNote: item.releaseNote || '',
          internalLog: '',
          isReadOnlyStr: item.isReadOnly ? 'true' : ''
        }
        if (this.user.role === 'admin') {
          getDb().ref('firmwareInternalLog').child('mt').child(key).once('value').then(sn => {
            this.form.internalLog = sn.val() || ''
          })
        }
        this.modalCb = this.applyUpdate
      }
      this.showModal = true
    },
    handleShowDeleteConfirm (key) {
      this.editingKey = key
      this.showDeleteConfirm = true
    },
    buildEntry () {
      const { selectedCustom, selectedCategory, version, isReleasedAt, selectedStatus, md5, testReportUrl, releaseNote, isReadOnlyStr, url, programmingFileUrl, programmingFileMd5 } = this.form
      return {
        customCategoryVersion: `${selectedCustom}_${selectedCategory}_${version}`,
        category: selectedCategory,
        createdAt: (new Date(isReleasedAt)).getTime(),
        custom: selectedCustom,
        md5,
        testReportUrl,
        releaseNote,
        status: selectedStatus,
        updatedAt: fb.database.ServerValue.TIMESTAMP,
        url,
        programmingFileUrl,
        programmingFileMd5,
        version,
        isReadOnly: isReadOnlyStr === 'true'
      }
    },
    applyUpload () {
      if (!this.form.selectedCategory || !this.form.selectedCustom || !this.form.url || !this.form.version || !this.form.selectedStatus || !this.form.isReleasedAt || !this.form.md5 || this.form.md5.length !== 32 || !this.form.programmingFileUrl || !this.form.programmingFileMd5 || this.form.programmingFileMd5.length !== 32) {
        this.showAlert = true
        return
      }
      const entry = this.buildEntry()
      if (this.user.role === 'admin' && this.form.internalLog) {
        entry.hasInternalLog = true
      }
      const newRef = getDb().ref('mt-firmware').push(entry)
      if (this.user.role === 'admin' && this.form.internalLog) {
        getDb().ref('firmwareInternalLog').child('mt').child(newRef.key).set(this.form.internalLog)
      }
      this.showModal = false
    },
    applyUpdate () {
      if (!this.form.selectedCategory || !this.form.selectedCustom || !this.form.url || !this.form.version || !this.form.selectedStatus || !this.form.isReleasedAt || !this.form.md5 || this.form.md5.length !== 32 || !this.form.programmingFileUrl || !this.form.programmingFileMd5 || this.form.programmingFileMd5.length !== 32) {
        this.showAlert = true
        return
      }
      const entry = this.buildEntry()
      if (this.user.role === 'admin') {
        entry.hasInternalLog = this.form.internalLog ? true : null
      }
      getDb().ref('mt-firmware').child(this.editingKey).update(entry)
      if (this.user.role === 'admin') {
        getDb().ref('firmwareInternalLog').child('mt').child(this.editingKey).set(this.form.internalLog || null)
        this.$set('internalLogs["' + this.editingKey + '"]', this.form.internalLog || '')
      }
      this.showModal = false
    },
    applyDelete () {
      getDb().ref('mt-firmware').child(this.editingKey).remove()
      if (this.user.role === 'admin') {
        getDb().ref('firmwareInternalLog').child('mt').child(this.editingKey).remove()
      }
      this.showDeleteConfirm = false
    },
    fetchInternalLog (fid) {
      if (this.user.role !== 'admin' && !this.isIntrising) return
      if (this.internalLogs[fid] !== undefined) return
      this.$set('internalLogs["' + fid + '"]', '')
      getDb().ref('firmwareInternalLog').child('mt').child(fid).once('value').then(sn => {
        this.$set('internalLogs["' + fid + '"]', sn.val() || '')
      })
    },
    prefetchVisibleInternalLogs () {
      if (this.user.role !== 'admin' && !this.isIntrising) return
      const visible = this.searchFilteredList.slice(this.pageStart, this.pageStart + this.countOfPage)
      for (const p of visible) {
        this.fetchInternalLog(p['.key'])
      }
    },
    buildClipboardUrl (version) {
      return `${window.location.origin}/mt-firmware?search=${version}`
    }
  },
  watch: {
    expandAll (newVal) {
      if (newVal) this.prefetchVisibleInternalLogs()
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../scss/_varaibles.scss';
@import '../../scss/_mixin.scss';
.upload_modal .form_label, .total, .function_bar .upload{
  text-align: right;
}
.function_bar {
  .upload{
    font-size: 20px;
  }
}
.form_label{
  padding: 5px 15px;
  white-space: nowrap;
}
.control_label{
  padding-right: 5px;
}

.upload_modal{
  .download{
    margin-left: -9px;
    margin-right: 9px;
  }
  .form-group{
    margin-bottom: 3px;
  }
  .form-group.larger_form_group{
    margin-bottom: 7px;
  }
}
.action_buttons{

}
.log_table{
  td {
    padding: 15px;
  }
  .media-top{
    display: flex;
    align-items: flex-start;
    .media-top__info {
      flex: 1 1 auto;
      min-width: 0;
      .version-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
      }
      .time {
        display: block;
        margin-top: -4px;
        margin-bottom: 4px;
      }
    }
    .action_buttons {
      flex-shrink: 0;
      padding: 4px 0;
    }
  }
  .version{
    display: inline-block;
    padding:3px 7px 3px 0px;
    font-size: 20px;
  }
  .time{
    color: #d7d7d7;
    padding-right:5px;
    .glyphicon{
      font-size: 10px;
      cursor: default;
      padding-right:5px;
    }
    span{
      font-size: 12px;
    }
  }
  span.download{
    cursor:pointer;
    span{
      font-size: 14px;
    }
  }
}
textarea{
  min-height: 200px;
  resize: vertical;
}
.single_log{
  position: relative;
  padding-right: 0px !important;
  border-right: none;
}
.badge_group{
  position: relative;
  min-width: 65px;
  overflow: hidden;
  border-left: none;
}
.customized__badge{
  &.develop{
    @include genRightCornerBadge(50px, 18px, 14px, $warning, #000);
    right:-52px;
  }
  &.release{
    @include genRightCornerBadge(50px, 18px, 14px, $info, #fff);
    right:-48px;
  }
  &.production{
    @include genRightCornerBadge(60px, 18px, 14px, $success, #fff);
    top: 18px;
    right:-65px;
  }
}
.copy-icon {
  cursor: pointer;
  &:hover {
    color: #007bff;
  }
}
</style>



// WEBPACK FOOTER //
// MTFirmware.vue?1caadbbc